import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
const PrimaryPriceComponentWrapper = ({ children, marginTop, }) => (_jsx(Box, { paddingTop: "spacing.16", paddingBottom: "spacing.8", marginTop: marginTop, children: children }));
const SecondaryPriceComponentWrapper = ({ children, marginTop, isLast = false, }) => {
    const borderProps = isLast
        ? {
            borderBottomLeftRadius: "radius.16",
            borderBottomRightRadius: "radius.16",
        }
        : {};
    return (_jsx(Box, Object.assign({}, borderProps, { backgroundColor: "color.background.light", paddingVertical: "spacing.16", marginTop: marginTop, children: children })));
};
const TertiaryPriceComponentWrapper = ({ children, marginTop, }) => (_jsx(Box, { paddingVertical: "spacing.16", marginTop: marginTop, children: children }));
export const ComponentWrapper = ({ type, children, marginTop, isLast = false, }) => {
    if (type === "TERTIARY") {
        return (_jsx(TertiaryPriceComponentWrapper, { marginTop: marginTop, children: children }));
    }
    if (type === "SECONDARY") {
        return (_jsx(SecondaryPriceComponentWrapper, { marginTop: marginTop, isLast: isLast, children: children }));
    }
    return (_jsx(PrimaryPriceComponentWrapper, { marginTop: marginTop, children: children }));
};
